import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material/styles';

export const classes: {
    defaultProps?: ComponentsProps['MuiInputAdornment'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiInputAdornment'];
    variants?: ComponentsVariants['MuiInputAdornment'];
} = {
    styleOverrides: {
        root: {
            fontSize: 15,
        },
        positionEnd: {
            maxHeight: '100%',
        },
    },
};
